import {
  CAMERA_CHECK_PERMISSIONS,
  CAMERA_GET_PHOTO,
  CAMERA_REQUEST_PERMISSIONS,
  type CameraGetPhotoOpts,
  type CameraGetPhotoResult,
  type CameraPermissionsResult,
} from '@/pwa/bridge-v2/protocol';
import type { Bridge } from '../bridge';

// =============================================================================
// bridge.camera — first-class camera plugin surface
// =============================================================================
// Thin typed wrappers over bridge.request for the Camera.* methods the host
// handlers implement directly. Native: backed by @capacitor/camera. PWA:
// permission methods short-circuit to a positive no-op; getPhoto works for
// `source: 'camera'` and `'photos'` via <input type="file">; `'prompt'`
// short-circuits with a clear error naming the supported sources.

export interface CameraSurface {
  checkPermissions(): Promise<CameraPermissionsResult>;
  requestPermissions(): Promise<CameraPermissionsResult>;
  getPhoto(opts?: CameraGetPhotoOpts): Promise<CameraGetPhotoResult>;
}

export const buildCamera = (b: Bridge): CameraSurface => ({
  checkPermissions: () =>
    b.request<CameraPermissionsResult>(CAMERA_CHECK_PERMISSIONS),
  requestPermissions: () =>
    b.request<CameraPermissionsResult>(CAMERA_REQUEST_PERMISSIONS),
  getPhoto: (opts) =>
    b.request<CameraGetPhotoResult>(CAMERA_GET_PHOTO, opts),
});
